/* 
 * Hide the color if all sizes of it are OOS
 * Implemented: layout\theme.liquid
 */

window.addEventListener('DOMContentLoaded', (event) => {
   function initOOSMainSwatch(){
   
     const scriptData = document.querySelector("script#product-data-unavailable").innerHTML;
     const {data} = JSON.parse(scriptData);
     // console.log("init", data)
    
    let filteredData = data.variants.reduce(function(accObj, currentObj) {
      accObj[currentObj.option1] = accObj[currentObj.option1] || [];
      accObj[currentObj.option1].push(currentObj);
      return accObj;
    }, {}); 
    
    //console.log("filteredData", filteredData);

    let OOSMainSwatchesColors = [];
    Object.entries(filteredData).map(swatch => {
     const areAllVariantsOOS = swatch[1].every(color => color.available === false);
      if(areAllVariantsOOS){
        OOSMainSwatchesColors.push(swatch[0]);
      }
    }) 
    console.log("all", OOSMainSwatchesColors);

    if(OOSMainSwatchesColors.length === 0){
      return console.log("Variants have stock - OOSMainSwatchesColors");
    }

    OOSMainSwatchesColors.forEach((swatch) => {
      const el = document.querySelector(`ul.check.box li[data-js-swatch="${swatch}"]`);
     console.log("el oos color - all variants", el); 
      el.style.display = "none";
    })

     // Hide color title and form buttons?
      
    
     
  }
  
    // first render
    initOOSMainSwatch()


    // variant onchnage
    document.addEventListener('click', ()=>{
        setTimeout(()=>{
            initOOSMainSwatch()
        },1100)

    })
})

